// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { EStatus, ILike } from '../../node/repositories/newbuilding-card/entities/reviews/Like';

export const getNewReactionCount = (currentState: EStatus) => {
  switch (currentState) {
    case EStatus.Disliked:
      return {
        [EStatus.Disliked]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
        [EStatus.Liked]: (like: ILike) => ({
          dislikesCount: Math.max(0, like.dislikesCount - 1),
          likesCount: like.likesCount + 1,
        }),
        [EStatus.Unknown]: (like: ILike) => ({
          dislikesCount: Math.max(0, like.dislikesCount - 1),
          likesCount: like.likesCount,
        }),
      };

    case EStatus.Liked:
      return {
        [EStatus.Disliked]: (like: ILike) => ({
          dislikesCount: like.dislikesCount + 1,
          likesCount: Math.max(0, like.likesCount - 1),
        }),
        [EStatus.Liked]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
        [EStatus.Unknown]: (like: ILike) => ({
          dislikesCount: like.dislikesCount,
          likesCount: Math.max(0, like.likesCount - 1),
        }),
      };
    default:
      return {
        [EStatus.Disliked]: (like: ILike) => ({
          dislikesCount: like.dislikesCount + 1,
          likesCount: like.likesCount,
        }),
        [EStatus.Liked]: (like: ILike) => ({
          dislikesCount: like.dislikesCount,
          likesCount: like.likesCount + 1,
        }),
        [EStatus.Unknown]: (like: ILike) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
      };
  }
};
